import React from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

const ProgressNotification = ({ 
  isVisible, 
  title, 
  progress, 
  total, 
  isComplete, 
  isError, 
  errorMessage,
  onClose 
}) => {
  if (!isVisible) return null;

  const percentage = total > 0 ? Math.round((progress / total) * 100) : 0;
  const isSuccess = isComplete && !isError;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm">
      <div className={`bg-white rounded-lg shadow-lg border p-4 transition-all duration-300 ${
        isError ? 'border-red-200' : isSuccess ? 'border-green-200' : 'border-blue-200'
      }`}>
        {/* Header */}
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center">
            {isError ? (
              <XCircleIcon className="h-5 w-5 text-red-500 mr-2" />
            ) : isSuccess ? (
              <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" />
            ) : (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500 mr-2"></div>
            )}
            <h4 className={`font-medium text-sm ${
              isError ? 'text-red-800' : isSuccess ? 'text-green-800' : 'text-blue-800'
            }`}>
              {title}
            </h4>
          </div>
          {isComplete && (
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <XCircleIcon className="h-4 w-4" />
            </button>
          )}
        </div>

        {/* Progress Bar */}
        {!isComplete && !isError && (
          <div className="mb-2">
            <div className="flex justify-between text-xs text-gray-600 mb-1">
              <span>{progress} of {total}</span>
              <span>{percentage}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-blue-500 h-2 rounded-full transition-all duration-300 ease-out"
                style={{ width: `${percentage}%` }}
              ></div>
            </div>
          </div>
        )}

        {/* Status Message */}
        <div className={`text-xs ${
          isError ? 'text-red-600' : isSuccess ? 'text-green-600' : 'text-gray-600'
        }`}>
          {isError ? (
            errorMessage || 'An error occurred'
          ) : isSuccess ? (
            `Successfully completed ${total} ${total === 1 ? 'class' : 'classes'}`
          ) : (
            total > 0 ? `Processing ${progress} of ${total} classes...` : 'Processing...'
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressNotification;
